import { createSlice } from "@reduxjs/toolkit";

//STATE
const state = {
  rows: [],
  showDialog: false,
  isLoading: false,
};

//STORE SLICE
export const itemCategoriesAddSlice = createSlice({
  name: "itemCategoriesAddSlice",
  initialState: state,
  //REDUCER
  reducers: {
    showAddItemCategoriesDialog(state) {
      return {
        ...state,
        showDialog: true,
      };
    },
    closeAddItemCategoriesDialog(state) {
      return {
        ...state,
        showDialog: false,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },    
  },
});

//ACTIONS
export const {
  showAddItemCategoriesDialog,
  closeAddItemCategoriesDialog,
  showLoading,
  hideLoading
} = itemCategoriesAddSlice.actions;

export default itemCategoriesAddSlice.reducer;
